import { useZaiHeroTitleModel } from './zai-hero-title.model'
import type { IZaiHeroTitleProps } from './zai-hero-title.types'
import { ZaiHeroTitleView } from './zai-hero-title.view'

export const ZaiHeroTitle = (props: IZaiHeroTitleProps) => {
  const model = useZaiHeroTitleModel(props)

  return <ZaiHeroTitleView {...model} />
}
